import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AllUsersRoutingModule } from './all-users-routing.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    AllUsersRoutingModule
  ]
})
export class AllUsersModule { }
